import React from "react";
import useRedirect from "../hooks/useRedirect";

function Redirect() {
  useRedirect();
  return <div></div>;
}

export default Redirect;
